import { columnsheadId } from '../../universal/columnshead';
import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import InternalStatisticsTypeEdit from './InternalStatisticsTypeEdit';
import { useContext, useEffect, useRef } from 'react';
import { SocketContext } from '../../../App';

export default function InternalStatisticsType(props: any) {

    const ref = useRef<any>(undefined);

    /** api服务id */
    const apiId = 'internalStatisticsType';

    const useContextData = useContext(SocketContext);
    const { contextData, setContextData } = useContextData;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            // handleChangeOne = ref.current.handleChangeOne;
        }

        //同步获取数据 async - await
        const fetchData = async () => {
        }

        if (contextData?.currentAreaId) {
            if (contextData?.refresh) {
                onRefresh({ areaId: contextData?.currentAreaId })
            }
        }

        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contextData?.currentAreaId]); //初始化数据

    const onRefresh = (item: any) => {
        const { areaId } = item;
        const currentData: initDataType = {
            apiId,
            sendPageData: {
                areaId
            }
        }
        ref.current.initData(currentData);
        setContextData({ ...contextData, refresh: false })
    }

    //表头
    const columnsHead = [
        {
            title: '地区',
            dataIndex: 'areaName',
            render: (text: any, record: any) => {
                if (record.internalStatisticsCategory.area) {
                    return (
                        <div>{record.internalStatisticsCategory.area.areaName}</div>
                    )
                }
            }
        },
        {
            title: '大分类',
            dataIndex: 'internalStatisticsCategoryName',
            render: (text: any, record: any) => {
                return (
                    <div>{record.internalStatisticsCategory.internalStatisticsCategoryName}</div>
                )
            }
        },
        {
            title: '小分类名称',
            dataIndex: 'internalStatisticsTypeName',
        },
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '内部统计小分类',
        apiId: 'internalStatisticsType',
        showStates: true,
        columns,
        pagination: true,
        EditComponent: InternalStatisticsTypeEdit,
        sendPageData: { areaId: contextData?.currentAreaId },
        mountDataOptions: {
            userMount: {
                isArea: true
            }
        }
    };

    return (
        <>
            <WebUniversalNewEx props={extendProps} ref={ref}></WebUniversalNewEx>
        </>
    )
}